module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Ga-Hb-Ia-inside.a28e71d1.png";